import api from '../lib/api';
import type { Paginated } from '../types';
import type { DistributorInitiative, DistributorInitiativeInput } from '../types/crm';

// The single-record endpoints (show/create/update) return a JSON:API-style
// envelope: `{ data: { id, type, attributes: {...flat record...} } }`. List
// endpoints return flat records directly inside `data`.

export const distributorInitiativeService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<DistributorInitiative>> => {
    const response = await api.get<Paginated<DistributorInitiative>>('/distributor_initiatives', { params });
    return response.data;
  },

  getById: async (id: number): Promise<DistributorInitiative> => {
    const response = await api.get<{ data: { attributes: DistributorInitiative } }>(`/distributor_initiatives/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: DistributorInitiativeInput): Promise<DistributorInitiative> => {
    const response = await api.post<{ data: { attributes: DistributorInitiative } }>('/distributor_initiatives', {
      distributor_initiative: data,
    });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<DistributorInitiativeInput>): Promise<DistributorInitiative> => {
    const response = await api.patch<{ data: { attributes: DistributorInitiative } }>(`/distributor_initiatives/${id}`, {
      distributor_initiative: data,
    });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/distributor_initiatives/${id}`);
  },
};

export default distributorInitiativeService;
